import SourceFlowText from "@sourceflow-uk/sourceflowtext"
import SourceFlowImage from "@sourceflow-uk/sourceflowimage"
import {
    Container,
    Row,
    Col,
    Card
} from 'reactstrap';
import styles from './styles.module.scss';
import Link from "next/link"
import SocialShare from '../../components/SocialShare';
import imagesMetaData from '@/.sourceflow/image_metadata.json';

export default function FeaturedBlogs({
    global,
    pathPrefix,
    customClass = "",
    content,
    post,
    locale,
    pagePrefix = "blog/"
}) {
    return (
        post?.length >= 1 && (
            <section className={`${styles.root} ${customClass}`}>
                <Container>
                    <Row className="mb-5">
                        <Col md={6} className="mb-4 mb-md-0">
                            {content ?
                                <SourceFlowText global={global} path={`${pathPrefix}.content`} type="html">
                                    {content}
                                </SourceFlowText>
                                : null}
                        </Col>
                        <Col md={6} className="d-flex justify-content-md-end align-items-center">
                            <p className="mb-0 me-3">Share Our Blog</p>
                            <SocialShare
                                customClass="insights-page-social-share"
                                post={`Insights`}
                                body={``}
                                twitter={true}
                                facebook={true}
                                linkedin={true}
                                email={true}
                                whatsapp={true}
                                urlPrefix={`blog`}
                                twitterText={`Share on Twitter`}
                                facebookText={`Share on Facebook`}
                                linkedinText={`Share on LinkedIn`}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col lg={6} className="left-column">
                            {post.slice(0, 1).map((post, index) =>
                                <Card className="rounded-4 h-100" key={index}>
                                    <Link href={`/${locale ? locale : ""}/${pagePrefix}${post.url_slug}/`}>
                                        <a className="d-flex flex-wrap h-100">
                                            <div className="p-4">
                                                <p className="post-title"><strong>{post?.title}</strong></p>
                                                {post?.short_description ?
                                                    <div className="post-description" dangerouslySetInnerHTML={{ __html: post?.short_description }} />
                                                    : ""}
                                                <div className="mt-4">
                                                    <span>
                                                        Read More
                                                    </span>
                                                </div>
                                            </div>
                                            <div className="position-relative w-100">
                                                <SourceFlowImage
                                                    src={post?.image ? post.image : "/site-assets/placeholders/img-placeholder.jpg"}
                                                    size="800x350"
                                                    alt={post?.title}
                                                    className="card-img h-100 w-100" />
                                                {/* {post?.tag ?
                                                    <div>
                                                        <span className="tertiary-bg text-black d-inline-block px-2 rounded-3 position-absolute post-tag"><small><strong>{post.tag}</strong></small></span>
                                                    </div> : null} */}
                                                {post?.tag.length >= 1 && (
                                                    <div className="position-absolute post-tag">
                                                        {post.tag?.map((post, index) => (
                                                            <span className="secondary-bg text-black d-inline-block px-2 rounded-3 me-2 mb-2" key={index}>
                                                                {post}
                                                            </span>
                                                        ))}
                                                    </div>
                                                )}
                                            </div>
                                        </a></Link>
                                </Card>
                            )}
                        </Col>
                        <Col lg={6} className="right-column d-flex flex-wrap">
                            {post.slice(0, 3).map((post, index) => {
                                if (index === 0) {
                                    // Skip rendering for the first item (index 0)
                                    return null;
                                }
                                return (
                                    <Card className={`rounded-4 ${index === 1 ? "mb-4" : null}`} key={index}>
                                        <Link href={`/${locale ? locale : ""}/${pagePrefix}${post.url_slug}/`}>
                                            <a className="d-block h-100">
                                                <Row className="h-100">
                                                    <Col lg={8}>
                                                        <div className="p-4">
                                                            <p className="post-title"><strong>{post?.title}</strong></p>
                                                            {post?.short_description ? (
                                                                <div className="post-description" dangerouslySetInnerHTML={{ __html: post?.short_description }} />
                                                            ) : null}
                                                            <div className="mt-4">
                                                                <span>
                                                                    Read More
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </Col>
                                                    <Col lg={4} className="position-relative">
                                                        <SourceFlowImage
                                                            src={post?.image ? post.image : "/site-assets/placeholders/img-placeholder.jpg"}
                                                            size="800x"
                                                            alt={post?.title}
                                                            className="card-img h-100 w-100"
                                                            imagesMetaData={imagesMetaData}
                                                            path={pathPrefix ? pathPrefix : (`${pathPrefix}.image`) }
                                                        />
                                                        {post?.tag.length >= 1 && (
                                                            <div className="position-absolute post-tag">
                                                                {post.tag?.map((post, index) => (
                                                                    <span className="secondary-bg text-black d-inline-block px-2 rounded-3 me-2 mb-2 text-nowrap" key={index}>
                                                                        {post}
                                                                    </span>
                                                                ))}
                                                            </div>
                                                        )}
                                                    </Col>
                                                </Row>
                                            </a>
                                        </Link>
                                    </Card>
                                );
                            })}
                        </Col>
                    </Row>
                </Container>
            </section>
        )
    )
}